const PendingStatusSVG = ({ className }: { className: string }) => (
    <svg
        className={className}
        width="57"
        height="59"
        viewBox="0 0 57 59"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M28.8188 57.7516C43.4693 57.7516 55.3589 46.2471 55.4699 32.0142C55.4708 31.9038 55.3811 31.8132 55.2707 31.8132L51.197 31.8133C51.0866 31.8133 50.9971 31.9038 50.9961 32.0142C50.8852 43.8428 40.9983 53.3984 28.8182 53.3984C16.5692 53.3984 6.63936 43.7344 6.63936 31.8133C6.63936 19.8921 16.5692 10.2281 28.8182 10.2281V13.6648C28.8182 13.8243 28.9957 13.9196 29.1287 13.8315L37.3449 8.38773C37.4594 8.31186 37.4651 8.14578 37.3561 8.06224L29.1399 1.76792C29.0083 1.66712 28.8182 1.76096 28.8182 1.92672L28.8188 5.87483C14.0994 5.87483 2.16699 17.4878 2.16699 31.8132C2.16699 46.1386 14.0994 57.7516 28.8188 57.7516Z"
            fill="#246AC1"
        />
        <path
            d="M21.1768 41.9669C21.1768 41.6907 21.4006 41.4669 21.6768 41.4669H35.963C36.2392 41.4669 36.463 41.6907 36.463 41.9669V43.503C36.463 43.7791 36.2392 44.003 35.963 44.003H21.6768C21.4006 44.003 21.1768 43.7791 21.1768 43.503V41.9669Z"
            fill="#0C2340"
        />
        <path
            d="M21.1768 19.5363C21.1768 19.2602 21.4006 19.0363 21.6768 19.0363H35.963C36.2392 19.0363 36.463 19.2602 36.463 19.5363V21.0724C36.463 21.3486 36.2392 21.5724 35.963 21.5724H21.6768C21.4006 21.5724 21.1768 21.3486 21.1768 21.0724V19.5363Z"
            fill="#0C2340"
        />
        <path
            d="M34.5644 21.5723V25.3654C34.5644 27.4847 33.1146 29.3448 31.0175 29.9159C30.9756 29.9273 30.9466 29.9645 30.9466 30.0069V31.2995V32.5921C30.9466 32.6347 30.9755 32.6723 31.0175 32.6844C33.1208 33.2888 34.5644 35.1684 34.5644 37.3027V41.4671M23.0771 21.5723V25.3654C23.0771 27.4847 24.527 29.3448 26.624 29.9159C26.6659 29.9274 26.6949 29.9646 26.6949 30.0069V31.2995V32.5921C26.6949 32.6348 26.6661 32.6724 26.624 32.6845C24.5207 33.2888 23.0771 35.1685 23.0771 37.3028V41.4671"
            stroke="#0C2340"
            strokeWidth="2"
        />
        <rect
            x="28.4092"
            y="30.9467"
            width="1.12"
            height="1.12088"
            rx="0.2"
            fill="#0C2340"
        />
        <rect
            width="1.12044"
            height="1.12044"
            rx="0.2"
            transform="matrix(0.706829 0.707384 -0.706829 0.707384 31.0186 34.5236)"
            fill="#0C2340"
        />
        <path
            d="M28.8419 28.6073C30.9153 28.6073 32.6318 27.3634 32.927 25.7421C32.9765 25.4704 32.7481 25.2447 32.4719 25.2447H25.2119C24.9358 25.2447 24.7073 25.4704 24.7568 25.7421C25.052 27.3634 26.7686 28.6073 28.8419 28.6073Z"
            fill="#0C2340"
        />
        <path
            d="M28.8419 37.1451C30.9211 37.1451 32.6415 38.4324 32.9295 40.1077C32.9763 40.3799 32.7481 40.6055 32.4719 40.6055H25.2119C24.9358 40.6055 24.7075 40.3799 24.7543 40.1077C25.0424 38.4324 26.7627 37.1451 28.8419 37.1451Z"
            fill="#0C2340"
        />
    </svg>
);

// eslint-disable-next-line import/no-default-export
export default PendingStatusSVG;
